<template>
  <div class="app">
    <!-- Header -->
    <Header />

    <div class="app-body">
      <Sidebar />

      <main class="app-main">
        <router-view :key="$route.path" />
      </main>
    </div>
  </div>
</template>

<script>
import Header from '@sh/components/Layout/Header/Header.vue';
import Sidebar from '@sh/components/Layout/Sidebar/Sidebar.vue';

export default {
  name: 'DashboardContainer',
  components: {
    Header,
    Sidebar,
  },
};
</script>

<style lang="scss">
  .app-body {
    padding-top: 6rem;

    .app-main {
      padding: 2.5rem;
      /* Sticky Footer */
      // padding-bottom: 0;
      margin-left: 25rem;
      transition: margin-left .25s ease-in-out;

      .content-wrapper {
        &.has-fixed-footer {
          padding-bottom: 6.6rem;
        }
      }
    }
  }

  .sidebar-minimized {
    .app-body {

      .app-main {
        margin-left: 5rem;

        .fixed-footer {
          margin-left: 5rem;
          width: calc(100% - 5rem);
        }
      }
    }
  }

  .section-header {
    &__content {
      &__title {
        font-size: 2.4rem;
        color: $color-primary;
        font-weight: 700;
      }

      &__subtitle {
        font-size: 1.4rem;
        color: #24C2F3;
        margin-left: 1rem;
        margin-top: .7rem;

        a {
          color: #24C2F3;
          font-weight: 500;
        }
      }
    }
  }

  @media (max-width: 767.98px) {
    .app-body {
      .app-main {
        padding: 1.5rem;
      }
      .app-sidebar {
        z-index: 999;
      }
      .app-main {
        margin-left: 0rem;
      }
    }

    .sidebar-minimized {
      .app-body {
        .app-sidebar {
          width: 0;
          &__nav {
            width: 0;
            &__item {
              width: 0;
              display: none;
            }
          }
        }
        .app-main {
          margin-left: 0rem;

          .fixed-footer {
            margin-left: 0rem;
            width: 100%;
          }
        }
      }
    }
  }
</style>
